import { render, staticRenderFns } from "./ConfigurationApplicationView.vue?vue&type=template&id=0a128208&scoped=true"
import script from "./ConfigurationApplicationView.vue?vue&type=script&lang=js"
export * from "./ConfigurationApplicationView.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationApplicationView.vue?vue&type=style&index=0&id=0a128208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a128208",
  null
  
)

export default component.exports